import { useEffect } from 'react'
import { logger } from '../utils/logger'

export function useClickLogger() {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      
      // Собираем информацию о клике
      const clickInfo = {
        tagName: target.tagName,
        id: target.id,
        className: target.className,
        textContent: target.textContent?.slice(0, 100), // Ограничиваем длину текста
        href: (target as HTMLAnchorElement).href,
        type: (target as HTMLInputElement).type,
        name: (target as HTMLInputElement).name,
        value: (target as HTMLInputElement).value,
        x: event.clientX,
        y: event.clientY,
        timestamp: new Date().toISOString()
      }

      logger.info('CLICK', `Клик по элементу: ${target.tagName}`, clickInfo)
    }

    // Добавляем обработчик клика
    document.addEventListener('click', handleClick, true)

    // Очищаем обработчик при размонтировании
    return () => {
      document.removeEventListener('click', handleClick, true)
    }
  }, [])
}
